export default __webpack_public_path__ + "static/media/loading.12845d3d.gif";